import React from 'react'

const AboutSection = ({data,backgroundImage}) => {
 

  return (
    <section 
      className="bg-fixed bg-cover min-h-[450px] relative py-[112px] pb-[30px] bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover', // or 'contain' based on your preference
        backgroundPosition: 'center',
      }}  
    >
          {/* <span className="left-[-23px] max-sm:left-[-47px] block text-[18px] leading-5 text-secondary1 absolute top-[50%] tracking-[3px] uppercase opacity-50 transform rotate-90 ">FEEL SPECIAL</span> */}
          <div className='w-full'>
            <div className="text-center">
              <h1 id='main-heading' className="md:text-[61px] font-lux max-sm:text-[41px] leading-[70px] max-sm:leading-[50px] text-white uppercase relative inline-block py-[53px] px-0 pb-[47px] tracking-[13px]">{data} </h1>
            </div>

          </div>
          {/* <span class="right-[-35px] max-sm:right-[-73px] block text-[18px] leading-5 transform rotate-90 absolute top-[50%] opacity-50 tracking-[3px] uppercase text-secondary1">TRENDS FOR 2024</span> */}
    </section>
  )
}

export default AboutSection